module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAmCAYAAAC29NkdAAAA70lEQVRYR+3WMQqEMBSE4SeIlYV4hFQ5ggewsPJMexnvYmVlYZWzLNlKFnaRzIxYvNQGPv+ER6plWV724FU5EDwdLwgGNC/oBX8VqOvaYoy27zsa6e/+4js4TZP1fW8pJVvXVYYsBoYQbBiGD0yJLAZm2Bl5HIdt20YvCQG/kfmoc03mgoFqJAWoRNKAKiQVqEDSgWykBMhEyoBd19k4jtY0DTTIJUAWLp8EHcjE0YFsHBWowNGAKhwFqMTBQDUOAt6Bg4DzPFvbttAQvvJuLJ6DuWB+USte0Wd4MfDK3zO+cSBa0Qt6QbQAuv/xd/ANCRLaoWCCX8YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/next.png
// module id = ky0h
// module chunks = 1